import axios from "axios";

export const apiPath = "/v1"

// Default Axios config
export default axios.create({
  baseURL: window.location.origin+apiPath,
  responseType: "json",
  crossDomain: true,
  withCredentials: true,
});
